import appointments from "./apiClient/organizations/appointments";

const translations = {
	next: {
		en: "Next",
		esp: "Siguiente",
		fr: "Prochain",
	},
	selectYourPets: {
		en: "Select Your Pet(s) Below",
		esp: "Seleccione a su(s) mascota(s) a continuación",
		fr: "Sélectionnez votre/vos animal/animaux ci-dessous",
	},
	OR: {
		en: "OR",
		esp: "O",
		fr: "OU",
	},
	johnDoe: {
		en: "John Doe",
		esp: "Juan Pérez",
		fr: "Monsieur X",
	},

	loginOrSignupTitle: {
		en: "Make an appointment",
		esp: "Haga una cita",
		fr: "Prendre un rendez-vous",
	},
	loginOrSignupSubTitle: {
		en: "We just need a few details to find you in our system",
		esp: "Solo necesitamos algunos detalles para encontrarte en nuestro sistema",
		fr: "Nous avons juste besoin de quelques détails pour vous trouver dans notre système",
	},
	loginOrSignEnterEmail: {
		en: "Enter the email address you used when you signed up",
		esp: "Ingresa el correo electrónico que usaste cuando te registraste",
		fr: "Entrez l’adresse e-mail que vous avez utilisée lors de votre inscription",
	},
	loginOrSignEnterPhone: {
		en: "Enter the phone number associated with your account",
		esp: "Ingresa el número de teléfono asociado con tu cuenta",
		fr: "Entrez le numéro de téléphone associé à votre compte",
	},
	loginTitle: {
		en: "Login",
		esp: "Iniciar sesión",
		fr: "S'identifier",
	},
	loginSubTitle: {
		en: "Welcome back! Please enter your password to log in",
		esp: "¡Bienvenido de nuevo! Por favor ingrese su contraseña para iniciar sesión",
		fr: "Bienvenue! Veuillez entrer votre mot de passe pour vous connecter",
	},
	signupTitle: {
		en: "Signup",
		esp: "Registrarse",
		fr: "S'inscrire",
	},
	signupSubTitle: {
		en: "It looks like we couldn't find an existing profile with that information. Let's get you set up!",
		esp: "¡Parece que no pudimos encontrar un perfil existente con esa información. ¡Vamos a registrarte!",
		fr: "Il semble que nous n'ayons pas pu trouver de profil existant avec ces informations. Inscrivez-vous!",
	},
	appointmentInformation: {
		en: "Appointment Information",
		esp: "Información de la cita",
		fr: "Informations sur le rendez-vous",
	},
	contactInformationTitle: {
		en: "Contact Information",
		esp: "Información de contacto",
		fr: "Informations de contact",
	},
	contactInformationSubTitle: {
		en: "Fill out your Personal Information",
		esp: "Complete su información personal",
		fr: "Remplissez vos informations personnelles",
	},
	whyDoWeNeedThis: {
		en: "Why do we need this?",
		esp: "¿Por qué necesitamos esto?",
		fr: "Pourquoi avons-nous besoin de cela?",
	},
	whyDoWeNeedThisRespond: {
		en: "We need these details to locate your existing profile and ensure a seamless experience for you and your pets.",
		esp: "Necesitamos estos detalles para ubicar tu perfil existente y garantizar una experiencia sin inconvenientes para ti y tus mascotas.",
		fr: "Nous avons besoin de ces informations pour localiser votre profil existant et garantir une expérience fluide pour vous et vos animaux de compagnie.",
	},
	pleaseAddAPatient: {
		en: "Please select or add a patient.",
		esp: "Por favor seleccione o agregue un paciente.",
		fr: "Veuillez sélectionner ou ajouter un patient.",
	},
	addNewPet: {
		en: "Add a new pet",
		esp: "Agregar una nueva mascota",
		fr: "Ajouter un nouvel animal",
	},
	numberOfPets: {
		en: "Number of Pets",
		esp: "Número de mascotas",
		fr: "Nombre d'animaux",
	},
	test: {
		en: "test",
		esp: "test",
		fr: "test",
	},
	numberOfPatients: {
		en: "Number of Patients",
		esp: "Número de pacientes",
		fr: "Nombre de patients",
	},
	loginforeasieraccess: {
		en: "Login for easier access!",
		esp: "Inicie sesión para un acceso más fácil",
		fr: "Connectez-vous pour un accès plus facile",
	},
	enterYourPassword: {
		en: "Enter your password",
		esp: "Ingresa tu contraseña",
		fr: "Entrez votre mot de passe",
	},
	newPassword: {
		en: "New Password",
		esp: "Nueva contraseña",
		fr: "Nouveau mot de passe",
	},
	confirmPassword: {
		en: "Confirm Password",
		esp: "Confirmar contraseña",
		fr: "Confirmer le mot de passe",
	},
	confirmNewPassword: {
		en: "Confirm New Password",
		esp: "Confirmar nueva contraseña",
		fr: "Confirmer le nouveau mot de passe",
	},
	login: {
		en: "Login",
		esp: "Iniciar sesión",
		fr: "S'identifier",
	},
	enterYourEmailOrPhoneNumber: {
		en: "Enter your email or mobile phone number",
		esp: "Ingrese su correo electrónico o número de teléfono móvil",
		fr: "Entrez votre e-mail ou votre numéro de téléphone mobile",
	},
	enterYourEmail: {
		en: "Enter your email",
		esp: "Introduce tu correo electrónico",
		fr: "Entrer votre Email",
	},
	enterYourPhoneNumber: {
		en: "Enter your mobile phone number",
		esp: "Introduzca su número de teléfono móvil",
		fr: "Entrez votre numéro de téléphone portable",
	},
	password: {
		en: "Password",
		esp: "Contraseña",
		fr: "Mot de passe",
	},
	passwordConfirmation: {
		en: "Password Confirmation",
		esp: "Confirmación de la contraseña",
		fr: "Confirmation du mot de passe",
	},
	invalidPassword: {
		en: "Invalid Password",
		esp: "Contraseña inválida",
		fr: "Mot de passe invalide",
	},
	passwordRuleLeastNumber: {
		en: "Has at least 1 number",
		esp: "Tiene al menos 1 número",
		fr: "Contient au moins 1 chiffre",
	},
	passwordRuleLeastUppercaseLetter: {
		en: "Has at least 1 uppercase letter",
		esp: "Tiene al menos 1 letra mayúscula",
		fr: "Contient au moins 1 lettre majuscule",
	},
	passwordRuleLeastLowercaseLetter: {
		en: "Has at least 1 lowercase letter",
		esp: "Tiene al menos 1 letra minúscula",
		fr: "Contient au moins 1 lettre minuscule",
	},
	passwordRuleLeastCharacters: {
		en: "Has at least 8 characters",
		esp: "Tiene al menos 8 caracteres",
		fr: "Contient au moins 8 caractères",
	},
	passwordRuleConfirmationMatched: {
		en: "Password Confirmation Matches",
		esp: "La confirmación de la contraseña coincide",
		fr: "La confirmation du mot de passe correspond",
	},
	itDoesNotMeetOneOrMoreOfTheCriteria: {
		en: "It does not meet one or more of the criteria",
		esp: "No cumple con uno o más de los criterios",
		fr: "Il ne répond pas à un ou plusieurs des critères",
	},
	noAppointments: {
		en: "No Appointment",
		esp: "Sin cita",
		fr: "Pas de rendez-vous",
	},
	forgotYourPassword: {
		en: "Forgot your password?",
		esp: "¿Olvidaste tu contraseña?",
		fr: "Mot de passe oublié?",
	},
	firstTimeLogin: {
		en: "Is this your first time logging in?",
		esp: "¿Es la primera vez que inicias sesión?",
		fr: "C'est la première fois que vous vous connectez ?",
	},
	resetPassword: {
		en: "Reset Password",
		esp: "Restablecer la contraseña",
		fr: "réinitialiser le mot de passe",
	},
	errorResettingPassword: {
		en: "There was an error resetting your password. Please try again.",
		esp: "Hubo un error al restablecer su contraseña. Por favor, inténtelo de nuevo.",
		fr: "Une erreur s'est produite lors de la réinitialisation de votre mot de passe. Veuillez réessayer.",
	},
	claimAccount: {
		en: "Claim Account",
		esp: "Reclamar cuenta",
		fr: "Compte de réclamation",
	},
	claimYourAccount: {
		en: "Claim Your Account",
		esp: "Reclama tu cuenta",
		fr: "Réclamez votre compte",
	},
	claimYourAccounDescription: {
		en: "Check your email address below, and we’ll send you an email with the instructions to claim your account.",
		esp: "Verifica tu dirección de correo electrónico a continuación, y te enviaremos un correo electrónico con las instrucciones para reclamar tu cuenta.",
		fr: "Vérifiez votre adresse e-mail ci-dessous, et nous vous enverrons un e-mail avec les instructions pour réclamer votre compte.",
	},
	resentMessageForClaimAccount: {
		en: "We’ve sent an email to your address. Please follow the instructions in the email to claim your account. If you don’t see the email, check your spam or junk folder.",
		esp: "Hemos enviado un correo electrónico a tu dirección. Siga las instrucciones en el correo electrónico para reclamar su cuenta. Si no ve el correo electrónico, revise su carpeta de spam o correo no deseado.",
		fr: "Nous avons envoyé un e-mail à votre adresse. Suivez les instructions dans l'e-mail pour réclamer votre compte. Si vous ne voyez pas l'e-mail, vérifiez votre dossier de spam ou de courrier indésirable.",
	},
	errorClaimingAccount: {
		en: "There was an error claiming your account. Please try again.",
		esp: "Hubo un error al reclamar su cuenta. Por favor, inténtelo de nuevo.",
		fr: "Une erreur s'est produite lors de la réclamation de votre compte. Veuillez réessayer.",
	},
	selectAnAppointmentType: {
		en: "Select an Appointment Type",
		esp: "Seleccione un tipo de cita",
		fr: "Sélectionnez un type de rendez-vous",
	},
	appointmentType: {
		en: "Appointment Type",
		esp: "Tipo de cita",
		fr: "Type de rendez-vous",
	},
	verifyingData: {
		en: "Verifying Data",
		esp: "Verificando datos",
		fr: "Vérification des données",
	},
	processingData: {
		en: "Processing data",
		esp: "Procesando datos",
		fr: "Données en cours",
	},
	selectYourAppointment: {
		en: "Select an Appointment Below",
		esp: "Seleccione una cita a continuación",
		fr: "Sélectionnez un rendez-vous ci-dessous",
	},
	selectDate: {
		en: "Select a date",
		esp: "Seleccionar una fecha",
		fr: "Sélectionner une date",
	},
	desiredDateOfAppointment: {
		en: "Desired Date of Appointment",
		esp: "Fecha deseada de nombramiento",
		fr: "Date désirée d'un rendez-vous",
	},
	noAppointments: {
		en: "No Appointments",
		esp: "Sin citas",
		fr: "sans rendez-vous",
	},
	thisEmailOrPhone: {
		en: "This email or phone already exists with ",
		esp: "Este correo electrónico o teléfono ya existe con ",
		fr: "Cet e-mail ou numéro de téléphone est reconnu comme client de ",
	},
	ifThisIsYourFirst: {
		en: ". If this is your first time logging in, please use the 'Reset Password' link below to access your account.",
		esp: "Si es la primera vez que inicia sesión, utilice el enlace 'Restablecer contraseña' a continuación para acceder a su cuenta.",
		fr: "Si c'est la première fois que vous vous connectez, veuillez utiliser le lien «Réinitialiser le mot de passe» ci-dessous pour accéder à votre compte.",
	},
	welcome: {
		en: "Welcome",
		esp: "Bienvenidos",
		fr: "Bienvenue",
	},
	clickHereToLogOut: {
		en: "Click here to log out.",
		esp: "Click aqui para salir.",
		fr: "Cliquez ici pour vous déconnecter",
	},
	clickHereTo: {
		en: "Click here to",
		esp: "Click aqui para",
		fr: "cliquez ici pour",
	},
	logout: {
		en: "log out",
		esp: "salir",
		fr: "vous déconnecter",
	},
	clickHereToGoBack: {
		en: "Go back.",
		esp: "Regresa.",
		fr: "Retourner.",
	},
	back: {
		en: "Back",
		esp: "Regresar",
		fr: "Retourner",
	},
	backToLogin: {
		en: "Back to Login",
		esp: "Volver a iniciar sesión",
		fr: "Retour à la connexion",
	},
	showMore: {
		en: "Show More",
		esp: "Mostrar más",
		fr: "Révèlera plus",
	},
	showLess: {
		en: "Show Less",
		esp: "Muestra menos",
		fr: "afficher moins",
	},
	patientName: {
		en: "Pet’s name",
		esp: "Nombre de la mascota",
		fr: "Nom de l'animal",
	},
	years: {
		en: "Years",
		esp: "Años",
		fr: "Ans",
	},
	ageMonths: {
		en: "Age Months",
		esp: "Meses de edad",
		fr: "Âge en mois",
	},
	ageDays: {
		en: "Age Days",
		esp: "Meses de edad",
		fr: "Âge en mois",
	},
	ageWeeks: {
		en: "Age Weeks",
		esp: "Meses de edad",
		fr: "Âge en mois",
	},
	ageYears: {
		en: "Age Years",
		esp: "Años de edad",
		fr: "l'âge en années",
	},
	gender: {
		en: "Gender",
		esp: "Género",
		fr: "Le sexe",
	},
	sex: {
		en: "Sex",
		esp: "Sexo",
		fr: "Sexe",
	},
	female: {
		en: "Female",
		esp: "Hembra",
		fr: "Fem",
	},
	male: {
		en: "Male",
		esp: "Macho",
		fr: "Mâle",
	},
	months: {
		en: "Months",
		esp: "Meses",
		fr: "Mois",
	},
	weeks: {
		en: "Weeks",
		esp: "Meses",
		fr: "Mois",
	},
	days: {
		en: "Days",
		esp: "Meses",
		fr: "Mois",
	},
	birthday: {
		en: "Birthday",
		esp: "Cumpleaños",
		fr: "Date d'anniversaire",
	},
	species: {
		en: "Species",
		esp: "Especies",
		fr: "Espèce",
	},
	breed: {
		en: "Breed",
		esp: "Raza",
		fr: "Race",
	},
	weight: {
		en: "Weight",
		esp: "Peso",
		fr: "Poids",
	},
	reasonForVisit: {
		en: "Reason for Visit",
		esp: "Razón de la visita",
		fr: "Raison de la visite",
	},
	update: {
		en: "Update",
		esp: "actualizar",
		fr: "actualiser",
	},
	create: {
		en: "Create",
		esp: "Crear",
		fr: "Créer",
	},
	contact: {
		en: "Contact",
		esp: "Contacto",
		fr: "Information de contact",
	},
	appointment: {
		en: "Appointment",
		esp: "Cita",
		fr: "Rendez-vous",
	},
	review: {
		en: "Review",
		esp: "Revisión",
		fr: "Examen",
	},
	finish: {
		en: "Finish",
		esp: "Terminar",
		fr: "Terminer",
	},
	email: {
		en: "Email",
		esp: "Correo electrónico",
		fr: "Email",
	},
	address: {
		en: "Address",
		esp: "Dirección",
		fr: "Adresse",
	},
	street: {
		en: "Street",
		esp: "Calle",
		fr: "Rue",
	},
	title: {
		en: "Title",
		esp: "Título",
		fr: "Titre",
	},
	name: {
		en: "Name",
		esp: "Nombre",
		fr: "Nom",
	},
	firstName: {
		en: "First Name",
		esp: "Primer Nombre",
		fr: "Prénom",
	},
	middleInitial: {
		en: "Middle Initial",
		esp: "inicial del segundo nombre",
		fr: "initiale",
	},
	lastName: {
		en: "Last Name",
		esp: "Apellido",
		fr: "Nom de famille",
	},
	mobilePhone: {
		en: "Mobile Phone",
		esp: "Teléfono móvil",
		fr: "Téléphone portable",
	},
	date: {
		en: "Date",
		esp: "Fecha",
		fr: "Date",
	},
	startTime: {
		en: "Start Time",
		esp: "Hora de inicio",
		fr: "Heure de début",
	},
	endTime: {
		en: "End Time",
		esp: "Hora de finalización",
		fr: "Heure de fin",
	},
	unit: {
		en: "Unit",
		esp: "Número de apartamento",
		fr: "Numéro d'appartement",
	},
	city: {
		en: "City",
		esp: "Ciudad",
		fr: "Ville",
	},
	state: {
		en: "State",
		esp: "Estado",
		fr: "État",
	},
	province: {
		en: "Province",
		esp: "Provincia",
		fr: "Province",
	},
	zipCode: {
		en: "Zip Code",
		esp: "Código postal",
		fr: "Code postal",
	},
	postalCode: {
		en: "Postal Code",
		esp: "Código postal",
		fr: "Code postal",
	},
	age: {
		en: "Age",
		esp: "Años",
		fr: "Âge",
	},
	birthdate: {
		en: "Birthdate",
		esp: "Fecha de nacimiento",
		fr: "Date de naissance",
	},
	iAgreeToReceiveTextMessageAlerts: {
		en: "I agree to receive text message alerts",
		esp: "Acepto recibir alertas de mensajes de texto",
		fr: "J'accepte de recevoir des alertes par SMS",
	},
	iAgreeToTheTermsOfService: {
		en: "I agree to the terms of service",
		esp: "Estoy de acuerdo con los términos de servicio",
		fr: "J'accepte les conditions d'utilisation",
	},
	termsOfUse: {
		en: "Terms of Use",
		esp: "Términos de Uso",
		fr: "Conditions d'utilisation",
	},
	privacyPolicy: {
		en: "Privacy Policy",
		esp: "Política de privacidad",
		fr: "Politique de confidentialité",
	},
	pleaseAcceptTermsAbove: {
		en: "Please accept the terms above",
		esp: "Por favor, acepta los términos anteriores.",
		fr: "Veuillez accepter les conditions ci-dessus.",
	},
	sorryThereWasErrorReservingYourAppointment: {
		en: "Sorry, there was an error reserving your appointment",
		esp: "Lo siento, hubo un error al reservar tu cita.",
		fr: "Désolé, une erreur s’est produite lors de la réservation de votre rendez-vous.",
	},
	submit: {
		en: "Submit",
		esp: "Enviar",
		fr: "Soumettre",
	},
	cancel: {
		en: "Cancel",
		esp: "Cancelar",
		fr: "Annuler",
	},
	thankYou: {
		en: "Thank you",
		esp: "Gracias",
		fr: "Merci",
	},
	ThankYouForSchedulingWithUs: {
		en: "Thank you for scheduling with us!",
		esp: "Gracias por programar con nosotros!",
		fr: "Merci d'avoir pris rendez-vous avec nous!",
	},
	seeYouSoon: {
		en: "See you soon",
		esp: "Hasta pronto",
		fr: "À bientôt",
	},
	yourAppointmentIsReady: {
		en: "Your appointment is ready",
		esp: "Su cita está lista",
		fr: "Votre rendez-vous est prêt",
	},
	petInformation: {
		en: "Pet’s information",
		esp: "Información de la mascota",
		fr: "Informations sur l'animal",
	},
	thankYouExclamation: {
		en: "Thank you!",
		esp: "¡Gracias!",
		fr: "Merci!",
	},
	yourAppointmentWith: {
		en: "Your appointment with ",
		esp: "Su cita con ",
		fr: "Votre rendez-vous avec",
	},
	hasBeenConfirmedFor: {
		en: "has been confirmed for ",
		esp: "ha sido confirmado para ",
		fr: "a été confirmé pour",
	},
	lbs: {
		en: "lbs",
		esp: "libras",
		fr: "Kg",
	},
	kg: {
		en: "Kg",
		esp: "Kg",
		fr: "Kg",
	},
	edit: {
		en: "Edit",
		esp: "Editar",
		fr: "Éditer",
	},
	color: {
		en: "Color",
		esp: "Color",
		fr: "Couleur",
	},
	and: {
		en: "and",
		fr: "et",
		esp: "y",
	},
	weLookForwardToSeeingYou: {
		en: "We look forward to seeing you",
		esp: "Esperamos verte",
		fr: "Nous avons hâte de vous voir",
	},
	iAgreeToGrant: {
		en: "I agree to grant ",
		esp: "Estoy de acuerdo en otorgar ",
		fr: "J'accepte d'accorder ",
	},
	accessToInformation: {
		en: "access to my information.",
		esp: "acceso a mi información.",
		fr: "accéder à mes informations.",
	},
	TOSFor: {
		en: "Terms of Service for ",
		esp: "Términos de servicio para ",
		fr: "Conditions d'utilisation pour ",
	},
	almostThere: {
		en: "Almost There!",
		esp: "¡Ya casi terminamos!",
		fr: "Nous y sommes presque !",
	},
	reviewAndSubmit: {
		en: "Scroll down to review and Submit.",
		esp: "Desplázate hacia abajo para revisar y enviar.",
		fr: "Faites défiler vers le bas pour revoir et soumettre.",
	},
	backToStart: {
		en: "Back to Start",
		esp: "Volver a empezar",
		fr: "Retour au début",
	},
	logOut: {
		en: "Log Out",
		esp: "Cerrar sesión",
		fr: "Se déconnecter",
	},
	doctorName: {
		en: "Doctor’s name",
		esp: "Nombre del doctor",
		fr: "Nom du médecin",
	},
	selectDoctorAndTime: {
		en: "Select Doctor and Time",
		esp: "Seleccione Doctor y Hora",
		fr: "Sélectionnez le médecin et l'heure",
	},
	addedToWaitlist: {
		en: "Click to be added to the waitlist!",
		esp: "¡Haga clic para ser agregado a la lista de espera!",
		fr: "Cliquez pour être ajouté à la liste d'attente!",
	},
	destroyMyWaitlist: {
		en: "Cancel my waitlist entry",
		esp: "Cancelar mi entrada a la lista de espera",
		fr: "Annuler mon entrée sur la liste d'attente",
	},
	person: {
		en: "Person",
		esp: "Persona",
		fr: "Personne",
	},
	people: {
		en: "People",
		esp: "Personas",
		fr: "Personnes",
	},
	inLine: {
		en: "in line",
		esp: "en línea",
		fr: "en ligne",
	},
	InLine: {
		en: "In line",
		esp: "En línea",
		fr: "En ligne",
	},
	theEstimatedWaitTimeIs: {
		en: "the estimated wait time is",
		esp: "el tiempo de espera estimado es",
		fr: "le temps d'attente estimé est",
	},
	youAreCurrentlyNumber: {
		en: "You are currently number",
		esp: "Actualmente eres el número",
		fr: "Vous êtes actuellement le numéro",
	},
	yourEstimatedWaitTimeIs: {
		en: "your estimated wait time is",
		esp: "su tiempo de espera estimado es",
		fr: "votre temps d'attente estimé est",
	},
	hour: {
		en: "hour",
		esp: "hora",
		fr: "heure",
	},
	hours: {
		en: "hours",
		esp: "horas",
		fr: "heures",
	},
	minute: {
		en: "minute",
		esp: "minuto",
		fr: "minute",
	},
	minutes: {
		en: "minutes",
		esp: "minutos",
		fr: "minutes",
	},
	seconds: {
		en: "seconds",
		esp: "segundos",
		fr: "secondes",
	},
	availability: {
		en: "Availability",
		esp: "Disponibilidad",
		fr: "Disponibilité",
	},
	thereIsNoOneAheadOfYou: {
		en: "There is no one ahead of you!",
		esp: "¡No hay nadie delante de ti!",
		fr: "Il n'y a personne devant vous !",
	},
	closedMessageWalkInHeader: {
		en: "Online check-in is currently unavailable for this clinic.",
		esp: "El registro en línea no está disponible actualmente para esta clínica.",
		fr: "L'enregistrement en ligne n'est actuellement pas disponible pour cette clinique.",
	},
	closedMessageWalkInContent: {
		en: "Please come back during the 'check-in' hours posted below, or walk in in any time the clinic is open.",
		esp: "Vuelva durante las horas de 'registro' publicadas a continuación, o venga en cualquier momento que la clínica esté abierta.",
		fr: "Revenez pendant les heures de «check-in» affichées ci-dessous, ou entrez à tout moment où la clinique est ouverte.",
	},
	goAHeadMessageContent:{
		en: "You can go ahead once and fill your pet’s information below",
		esp: "Puede continuar y completar la información de su mascota a continuación",
		fr: "Vous pouvez continuer et remplir les informations de votre animal de compagnie ci-dessous",
	},
	youAreNextInLine:{
		en: "You are next in line!",
		esp: "¡Eres el siguiente en la fila!",
		fr: "Vous êtes le prochain en ligne!",
	},
	vetIsReadyMessage:{
		en: "The vet is ready to see your pet(s) now",
		esp: "El veterinario está listo para ver a tu(s) mascota(s) ahora",
		fr: "Le vétérinaire est prêt à voir votre/vos animal/animaux maintenant",
	},
	open: {
		en: "Open",
		esp: "Abierto",
		fr: "Ouvert",
	},
	closed: {
		en: "Closed",
		esp: "Cerrado",
		fr: "Fermé",
	},

	closesAt: {
		en: "closes at",
		esp: "cierra a las",
		fr: "ferme à",
	},
	opensAt: {
		en: "opens at",
		esp: "abre a las",
		fr: "ouvre à",
	},
	clinicHours: {
		en: "Clinic Hours",
		esp: "Horario de la clínica",
		fr: "Heures de la clinique",
	},
	onlineCheckIn: {
		en: "Online Check-In",
		esp: "Registro en línea",
		fr: "Enregistrement en ligne",
	},
	showLessHours: {
		en: "Show Less Hours",
		esp: "Mostrar menos horas",
		fr: "Afficher moins d'heures",
	},
	showMoreHours: {
		en: "Show More Hours",
		esp: "Mostrar más horas",
		fr: "Afficher plus d'heures",
	},
	skipToAvailable: {
		en: "Skip to next available appointment",
		esp: "Pasar a la próxima cita disponible",
		fr: "Passer au prochain rendez-vous disponible",
	},
	sorryNoFurtherAppointments: {
		en: "Sorry, this provider does not have any further appointments",
		esp: "Lo sentimos, este proveedor no tiene más citas",
		fr: "Désolé, ce fournisseur n'a plus de rendez-vous",
	},
	noProvideNew: {
		en: "We do not currently provide online booking. Please contact us via phone or email to inquire about scheduling an appointment. We apologize for any inconvenience. Please contact us if you have an urgent case that can not wait for our next available date.",
		esp: "Nos disculpamos, pero actualmente no estamos aceptando nuevos clientes a través de reservas en línea. Llame a la clínica para concertar una cita.",
		fr: "Nous ne proposons actuellement pas de réservation en ligne. Veuillez nous contacter par téléphone ou par e-mail pour vous renseigner sur la prise de rendez-vous. Nous nous excusons pour tout inconvénient. Veuillez nous contacter si vous avez un cas urgent qui ne peut pas attendre notre prochaine date disponible. Merci",
	},
	noProvideExisting: {
		en: "We do not currently provide online booking. Please contact us via phone or email to inquire about scheduling an appointment. We apologize for any inconvenience. Please contact us if you have an urgent case that can not wait for our next available date.",
		esp: "Nos disculpamos, pero actualmente no aceptamos clientes existentes a través de reservas en línea. Llame a la clínica para concertar una cita.",
		fr: "Nous ne proposons actuellement pas de réservation en ligne. Veuillez nous contacter par téléphone ou par e-mail pour vous renseigner sur la prise de rendez-vous. Nous nous excusons pour tout inconvénient. Veuillez nous contacter si vous avez un cas urgent qui ne peut pas attendre notre prochaine date disponible. Merci",
	},
	noBooking: {
		en: "We do not currently provide online booking. Please contact us via phone or email for more information or to inquire about scheduling an appointment. We apologize for any inconvenience. Thank you!",
		esp: "Actualmente no ofrecemos reservas en línea para su área. Comuníquese con nosotros por teléfono o correo electrónico para obtener más información o para pregunte acerca de programar una cita. Nos disculpamos por cualquier inconveniente. ¡Gracias!",
		fr: "Nous ne proposons actuellement pas de réservation en ligne. Veuillez nous contacter par téléphone ou par e-mail pour vous renseigner sur la prise de rendez-vous. Nous nous excusons pour tout inconvénient. Veuillez nous contacter si vous avez un cas urgent qui ne peut pas attendre notre prochaine date disponible. Merci",
	},
	noBookingForNew: {
		en: "We do not currently provide online booking for new clients. Please contact us via phone or email for more information or to inquire about scheduling an appointment. We apologize for any inconvenience.",
		esp: "Actualmente no proporcionamos reservas en línea para nuevos clientes. Póngase en contacto con nosotros por teléfono o correo electrónico para obtener más información o para solicitar una cita. Nos disculpamos por cualquier inconveniente.",
		fr: "Nous ne proposons pas actuellement de réservation en ligne pour les nouveaux clients. Veuillez nous contacter par téléphone ou par e-mail pour plus d'informations ou pour demander un rendez-vous. Nous nous excusons pour tout inconvénient.",
	},
	noBookingForReturning: {
		en: "We do not currently provide online booking for returning clients. Please contact us via phone or email for more information or to inquire about scheduling an appointment. We apologize for any inconvenience.",
		esp: "Actualmente no proporcionamos reservas en línea para clientes que regresan. Póngase en contacto con nosotros por teléfono o correo electrónico para obtener más información o para solicitar una cita. Nos disculpamos por cualquier inconveniente.",
		fr: "Nous ne proposons pas actuellement de réservation en ligne pour les clients qui reviennent. Veuillez nous contacter par téléphone ou par e-mail pour plus d'informations ou pour demander un rendez-vous. Nous nous excusons pour tout inconvénient.",
	},
	providers: {
		en: "Providers",
		esp: "Proveedores",
		fr: "Fournisseurs",
	},
	allProviders: {
		en: "All Providers",
		esp: "Todos los proveedores",
		fr: "Tous les fournisseurs",
	},
	not: {
		en: "Not ",
		esp: "No ",
		fr: "ne pas",
	},
	go: {
		en: "Go",
		esp: "Vamos",
		fr: "Aller",
	},
	monday: {
		en: "Monday",
		esp: "lunes",
		fr: "Lundi",
	},
	tuesday: {
		en: "Tuesday",
		esp: "martes",
		fr: "Mardi",
	},
	wednesday: {
		en: "Wednesday",
		esp: "miércoles",
		fr: "Mercredi",
	},
	thursday: {
		en: "Thursday",
		esp: "jueves",
		fr: "Jeudi",
	},
	friday: {
		en: "Friday",
		esp: "viernes",
		fr: "Vendredi",
	},
	saturday: {
		en: "Saturday",
		esp: "sábado",
		fr: "samedi",
	},
	sunday: {
		en: "Sunday",
		esp: "domingo",
		fr: "dimanche",
	},
	mon: {
		en: "Mon",
		esp: "Lun",
		fr: "Lun",
	},
	tue: {
		en: "Tues",
		esp: "Mar",
		fr: "Mar",
	},
	wed: {
		en: "Wed",
		esp: "Mié",
		fr: "Mer",
	},
	thu: {
		en: "Thu",
		esp: "Jue",
		fr: "Jeu",
	},
	fri: {
		en: "Fri",
		esp: "Vie",
		fr: "Ven",
	},
	sat: {
		en: "Sat",
		esp: "Sáb",
		fr: "Sam",
	},
	sun: {
		en: "Sun",
		esp: "Dom",
		fr: "Dim",
	},
	mo: {
		en: "Mo",
		esp: "Lu",
		fr: "Lu",
	},
	tu: {
		en: "Tu",
		esp: "Ma",
		fr: "Ma",
	},
	we: {
		en: "We",
		esp: "Mi",
		fr: "Me",
	},
	th: {
		en: "Th",
		esp: "Ju",
		fr: "Je",
	},
	fr: {
		en: "Fr",
		esp: "Vi",
		fr: "Ve",
	},
	sa: {
		en: "Sa",
		esp: "Sá",
		fr: "Sa",
	},
	su: {
		en: "Su",
		esp: "Do",
		fr: "Di",
	},
	theWeek: {
		en: "The Week",
		esp: "la semana",
		fr: "La semaine",
	},
	jan: {
		en: "Jan",
		esp: "Ene",
		fr: "Jan",
	},
	feb: {
		en: "Feb",
		esp: "Feb",
		fr: "Fév",
	},
	mar: {
		en: "Mar",
		esp: "Mar",
		fr: "Mar",
	},
	apr: {
		en: "Apr",
		esp: "Abr",
		fr: "Avr",
	},
	may: {
		en: "May",
		esp: "May",
		fr: "Mai",
	},
	jun: {
		en: "Jun",
		esp: "Jun",
		fr: "Jui",
	},
	jul: {
		en: "Jul",
		esp: "Jul",
		fr: "Juil",
	},
	aug: {
		en: "Aug",
		esp: "Ago",
		fr: "Aoû",
	},
	sep: {
		en: "Sep",
		esp: "Sep",
		fr: "Sep",
	},
	oct: {
		en: "Oct",
		esp: "Oct",
		fr: "Oct",
	},
	nov: {
		en: "Nov",
		esp: "Nov",
		fr: "Nov",
	},
	dec: {
		en: "Dec",
		esp: "Dic",
		fr: "Déc",
	},
	january: {
		en: "January",
		esp: "enero",
		fr: "janvier",
	},
	february: {
		en: "February",
		esp: "febrero",
		fr: "février",
	},
	march: {
		en: "March",
		esp: "marzo",
		fr: "Mars",
	},
	april: {
		en: "April",
		esp: "abril",
		fr: "avril",
	},
	june: {
		en: "June",
		esp: "junio",
		fr: "juin",
	},
	july: {
		en: "July",
		esp: "julio",
		fr: "juillet",
	},
	august: {
		en: "August",
		esp: "agosto",
		fr: "août",
	},
	september: {
		en: "September",
		esp: "septiembre",
		fr: "septembre",
	},
	october: {
		en: "October",
		esp: "octubre",
		fr: "octobre",
	},
	november: {
		en: "November",
		esp: "noviembre",
		fr: "novembre",
	},
	december: {
		en: "December",
		esp: "diciembre",
		fr: "décembre",
	},
	emailOrPhone: {
		en: "Email or Phone",
		esp: "Email o teléfono",
		fr: "Email ou téléphone",
	},
	at: {
		en: "at",
		esp: "a",
		fr: "à",
	},
	selectYourProfile: {
		en: "Select Your Profile",
		fr: "Sélectionnez votre profil",
		esp: "Seleccione su perfil",
	},
	noBookingThisFarOut: {
		en: "This practice does not allow online booking this far into the future.",
		fr: "Cette pratique ne permet pas de réserver en ligne aussi loin dans le futur.",
		esp: "Esta práctica no permite la reserva en línea en un futuro tan lejano.",
	},
	gettingYourAppointmentScheduled: {
		en: "Getting your appointment scheduled!",
		fr: "Planification de votre rendez-vous!",
		esp: "Programación de su cita!",
	},
	pleaseDoNotClickAwayFromThisPage: {
		en: "Please do not click away from this page.",
		fr: "Veuillez ne pas cliquer sur cette page.",
		esp: "Por favor no haga clic fuera de esta página.",
	},
	makeYourAppointment: {
		en: "Make your appointment",
		fr: "Prenez rendez-vous",
		esp: "Haga su cita",
	},
	reviewYourInformation: {
		en: "Review your information",
		fr: "Vérifiez vos informations",
		esp: "Revise su información",
	},
	reviewYourInformation: {
		en: "Review your information",
		fr: "Vérifiez vos informations",
		esp: "Revise su información",
	},
	forgotYourPassword: {
		en: "Forgot your password?",
		esp: "¿Olvidaste tu contraseña?",
		fr: "Mot de passe oublié?",
	},
	forgotYourPasswordDescription: {
		en: "Enter your email address below, and we’ll send you a link to reset your password",
		esp: "Ingrese su dirección de correo electrónico a continuación y le enviaremos un enlace para restablecer su contraseña",
		fr: "Entrez votre adresse e-mail ci-dessous et nous vous enverrons un lien pour réinitialiser votre mot de passe",
	},
	pleaseConfirmYourContactInformation: {
		en: "Please confirm your contact information:",
		esp: "Confirme su información de contacto:",
		fr: "Veuillez confirmer vos coordonnées:",
	},
	send: {
		en: "Send",
		esp: "Enviar",
		fr: "Envoyer",
	},
	checkYourInbox: {
		en: "Check your inbox",
		esp: "Revisa tu bandeja de entrada",
		fr: "Vérifiez votre boîte de réception",
	},
	resentMessageForPasswordReset: {
		en: "We’ve sent a password reset link to your email. Please follow the instructions in the email to reset your password. If you don't see the email, check your spam or junk folder.",
		esp: "Hemos enviado un enlace de restablecimiento de contraseña a su correo electrónico. Siga las instrucciones del correo electrónico para restablecer su contraseña. Si no ve el correo electrónico, revise su carpeta de spam o correo no deseado.",
		fr: "Nous avons envoyé un lien de réinitialisation de mot de passe à votre adresse e-mail. Suivez les instructions dans l'e-mail pour réinitialiser votre mot de passe. Si vous ne voyez pas l'e-mail, vérifiez votre dossier spam ou courrier indésirable.",
	},
	LoginErrorLockedAccount: {
		en: "This account is currently locked due to too many failed attempts, please try again in 30 minutes.",
		esp: "Esta cuenta está actualmente bloqueada debido a demasiados intentos fallidos, por favor intente de nuevo en 30 minutos.",
		fr: "Ce compte est actuellement verrouillé en raison de trop de tentatives échouées, veuillez réessayer dans 30 minutes.",
	},
	LoginErrorIncorrectCredentials: {
		en: "The password or email/phone number entered is incorrect.",
		esp: "La contraseña o el correo electrónico/número de teléfono ingresado es incorrecto.",
		fr: "Le mot de passe ou l'e-mail/numéro de téléphone saisi est incorrect.",
	},
	LoginErrorEnterCredentials: {
		en: "Please enter an email or mobile phone number.",
		esp: "Por favor ingrese un correo electrónico o número de teléfono móvil.",
		fr: "Veuillez entrer un e-mail ou un numéro de téléphone mobile.",
	},
	extraFields: {
		en: "Extra Fields",
		esp: "Campos extra",
		fr: "Champs supplémentaires",
	},
	selectNewTimeSlot: {
		en: "Select New Time Slot",
		esp: "Seleccionar nuevo horario",
		fr: "Sélectionner un nouveau créneau horaire",
	},
	errorInvalidTimeSlot: {
		en: "The time slot you selected is no longer valid.",
		esp: "El horario que seleccionaste ya no es válido.",
		fr: "Le créneau horaire que vous avez sélectionné n’est plus valide.",
	},
	clickNewTimeSlot: {
		en: "Click above to select a new time slot.",
		esp: "Haz clic arriba para seleccionar una nuevo horario.",
		fr: "Cliquez ci-dessus pour sélectionner un nouveau créneau horaire.",
	},
	scrollUpToSelectNewTimeSlot: {
		en: "Please scroll up to review and select a new time slot.",
		esp: "Por favor, desplázate hacia arriba para revisar y seleccionar una nueva franja horaria.",
		fr: "Veuillez faire défiler vers le haut pour revoir et sélectionner un nouveau créneau horaire.",
	},
	selectPayment: {
		en: "Please select your payment options",
		esp: "Por favor seleccione sus opciones de pago",
		fr: "Veuillez sélectionner vos options de paiement",
	},
	newCard: {
		en: "New card",
		esp: "Nueva tarjeta",
		fr: "Nouvelle carte",
	},
	expires: {
		en: "Expires",
		esp: "Expira",
		fr: "Expire",
	},
	loadingForToAddNewCard: {
		en: "Loading form to add new card",
		esp: "Cargando formulario para agregar nueva tarjeta",
		fr: "Chargement du formulaire pour ajouter une nouvelle carte",
	},
	nameOnCard: {
		en: "Name on Card",
		esp: "Nombre en la tarjeta",
		fr: "Nom sur la carte",
	},
	cardNumber: {
		en: "Card Number",
		esp: "Número de tarjeta",
		fr: "Numéro de carte",
	},
	expiration: {
		en: "Expiration",
		esp: "Vencimiento",
		fr: "Expiration",
	},
	securityCode: {
		en: "Security Code",
		esp: "Código de seguridad",
		fr: "Code de sécurité",
	},
	noCards: {
		en: "There are no saved cards.",
		esp: "No hay tarjetas guardadas.",
		fr: "Il n'y a pas de cartes enregistrées.",
	},
	addNewCard: {
		en: "Add New Card",
		esp: "Agregar nueva tarjeta",
		fr: "Ajouter une nouvelle carte",
	},
	add: {
		en: "Add",
		esp: "Agregar",
		fr: "Ajouter",
	}
};
class I18n {
	setLocale(locale) {
		this._locale = locale;
	}
	translate(key) {
		return _.get(translations, `[${key}][${this._locale}]`);
	}
}
I18n.translations = translations;
export default I18n;



// WEBPACK FOOTER //
// ./lib/i18n.js